import $ from "jquery";

$(function() {
    $(".bl-hero").each(function() {
        const $bl = $(this);
        initHero($bl);
    });
});

function initHero($bl) {
    const $scrolldownarrow = $bl.find(".ctrarrow");
	$scrolldownarrow.on("click", function() {
		const $nextElement = $bl.next();
		$(window).scrollTo($nextElement, 500, {
			offset: -100
		});
	});
}
